import { fromNullable, none, Option, some } from 'fp-ts/lib/Option';
import { getLang } from '../app';
import { query } from '../shape/functions';
import { RemoteResource } from '../source';
import { ServiceDescription, ServiceResponse } from './io';

const remoteGeocoderToOption = <D, E>(rr: RemoteResource<D, E>) => {
    switch (rr.tag) {
        case 'success':
            return some(rr.data);
        case 'error':
            // kind is a placeholder: an error response carries no results
            return some({
                kind: 'term' as const,
                results: [],
                error: rr.error,
            });
        case 'loading':
        default:
            return none;
    }
};

export const getServiceResponse = (): Option<ServiceResponse> =>
    fromNullable(query('app/geocoder').response).chain(r =>
        remoteGeocoderToOption(r),
    );

export const getAllServices = (): ServiceDescription[] =>
    query('app/geocoder').serviceList;

export const getAllServicesCodes = () => getAllServices().map(s => s.code);

export const getServiceName = (serviceCode: string) =>
    fromNullable(getAllServices().find(s => s['code'] === serviceCode))
        .chain(s => fromNullable(s['name']))
        .chain(n => fromNullable(n[getLang()]))
        .getOrElse('');

export const getServicePlaceholder = (serviceCode: string) =>
    fromNullable(getAllServices().find(s => s['code'] === serviceCode))
        .chain(s => fromNullable(s['placeholder']))
        .chain(n => fromNullable(n[getLang()]))
        .getOrElse('');

export const getSelectedService = () =>
    fromNullable(query('app/geocoder').selected);

export const getTerm = () => query('app/geocoder/input');
